export const YOUTUBE_REGEX = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/;
export const VIMEO_REGEX = /vimeo\.com\/(\d+)/;

export const resolveVideoThumbnailUrl = (videoType, videoUrl, storedThumbnailUrl) => {
  if (storedThumbnailUrl) return storedThumbnailUrl;
  if (!videoUrl) return null;

  if (videoType === 'youtube') {
    const match = videoUrl.match(YOUTUBE_REGEX);
    if (match) return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
  }

  return null;
};

export const getVideoEmbedUrl = (videoType, videoUrl, { autoplay = false } = {}) => {
  if (!videoType || videoType === 'none' || !videoUrl) return null;

  const autoplayParam = autoplay ? '&autoplay=1' : '';

  if (videoType === 'youtube') {
    const match = videoUrl.match(YOUTUBE_REGEX);
    if (match) return `https://www.youtube.com/embed/${match[1]}?rel=0${autoplayParam}`;
  }

  if (videoType === 'vimeo') {
    const match = videoUrl.match(VIMEO_REGEX);
    if (match) return `https://player.vimeo.com/video/${match[1]}${autoplay ? '?autoplay=1' : ''}`;
  }

  return videoUrl;
};
